import { useCallback, useEffect, useRef, useState } from 'react'
import { assistantHealth } from '../../generic/Assistant_Api'

/**
 * Checks the assistant gateway health. The assistant is not deployed on every
 * MIC and, without it, the proxy fallback may answer the health path with a
 * 200 and the SPA's index.html — hence the check on `service`, not just on a
 * successful response. While the gateway is down the assistant UI must not be
 * shown at all, so this resolves to false on any failure, silently.
 *
 * Returns { available, recheck }: `recheck` re-runs the probe, so a chat call
 * failing with a network error can hide an assistant that has gone away.
 */
const useAssistantAvailable = () => {
  const [available, setAvailable] = useState(false)
  const mountedRef = useRef(true)

  useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])

  const recheck = useCallback(() => {
    return assistantHealth()
      .then(health => {
        if (mountedRef.current) {
          setAvailable(health.service === 'mic-assistant')
        }
      })
      .catch(() => {
        if (mountedRef.current) {
          setAvailable(false)
        }
      })
  }, [])

  useEffect(() => {
    recheck()
  }, [recheck])

  return { available, recheck }
}

export default useAssistantAvailable
